import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { useSelector } from 'react-redux';
import useAuthRedirect from '@common/hooks/useAuthRedirect';
import routes from '@common/routes/index';
import styles from './ClerkSignIn.module.css';
import { selectColorScheme } from '@src/features/interface/interfaceSlice';

/**
 * Clerk-based SignIn component
 * Wraps Clerk's SignIn component with application styling and theme
 * Maintains compatibility with existing authentication flow
 */
const ClerkSignIn = (): React.JSX.Element | null => {
  const { isSignedIn, isLoaded } = useAuth();
  const { getRedirectUrl } = useAuthRedirect();
  const colorScheme = useSelector(selectColorScheme);

  // Wait for auth state to be loaded
  if (!isLoaded) {
    return null;
  }

  // Redirect if already signed in - preserve the intended destination
  if (isSignedIn) {
    const redirectTo = getRedirectUrl();
    return <Navigate to={redirectTo} replace />;
  }

  // Determine the redirect URL after successful sign-in
  const redirectAfterSignIn = getRedirectUrl();

  return (
    <div className={styles.SignInContainer}>
      <SignIn 
        routing="hash"
        // path={routes.auth.getSignInRoute()}
        signUpUrl={routes.auth.getSignUpRoute()}
        forceRedirectUrl={redirectAfterSignIn}
        appearance={{
          captcha: {
            theme: colorScheme
          },
          elements: {
            rootBox: styles.ClerkRootBox,
            // card: styles.ClerkCard,
            headerTitle: styles.ClerkHeaderTitle,
            headerSubtitle: styles.ClerkHeaderSubtitle,
            socialButtonsBlockButton: { display: 'none' },
            socialButtonsProviderIcon: { display: 'none' },
            dividerRow: { display: 'none' },
            formButtonPrimary: styles.ClerkSubmitButton,
            formFieldInput: styles.ClerkInput,
            formFieldLabel: styles.ClerkLabel,
            identityPreviewText: styles.ClerkIdentityText,
            formResendCodeLink: styles.ClerkLink,
            footerActionLink: styles.ClerkFooterLink,
            footer: styles.ClerkFooter,
          },
        }}
      />
    </div>
  );
};

export default ClerkSignIn;
